/* We would have to generate a new icon subset package if we add new icons to the list below. Please go to
https://eng.ms/docs/experiences-devices/data-platform-growth/taos/o2/office-home-service/office-start-documentation/dev-docs/icons/adding-font-icons
for instructions. */
export var IconNames;
(function (IconNames) {
    IconNames["Accounts"] = "Accounts";
    IconNames["Add"] = "Add";
    IconNames["AlertSolid"] = "AlertSolid";
    IconNames["Attach"] = "Attach";
    IconNames["Calendar"] = "Calendar";
    IconNames["Cancel"] = "Cancel";
    IconNames["Chat"] = "Chat";
    IconNames["CheckMark"] = "CheckMark";
    IconNames["ChevronDown"] = "ChevronDown";
    IconNames["ChevronLeft"] = "ChevronLeft";
    IconNames["ChevronRight"] = "ChevronRight";
    IconNames["ChromeClose"] = "ChromeClose";
    IconNames["CircleFill"] = "CircleFill";
    IconNames["CirclePlus"] = "CirclePlus";
    IconNames["Clock"] = "Clock";
    IconNames["Comment"] = "Comment";
    IconNames["Community"] = "Group";
    IconNames["Compass"] = "CompassNW";
    IconNames["Cube"] = "CubeShape";
    IconNames["Delete"] = "Delete";
    IconNames["Desktop"] = "TVMonitor";
    IconNames["Diamond"] = "Diamond";
    IconNames["DocumentSearch"] = "DocumentSearch";
    IconNames["Download"] = "Download";
    IconNames["Edit"] = "Edit";
    IconNames["EditSolid"] = "EditSolid12";
    IconNames["ExcelLogo"] = "ExcelLogo";
    IconNames["ExploreContent"] = "ExploreContent";
    IconNames["FabricFolder"] = "FabricFolder";
    IconNames["FavoriteStar"] = "FavoriteStar";
    IconNames["Filter"] = "Filter";
    IconNames["Flag"] = "Flag";
    IconNames["FluidLogo"] = "FluidLogo";
    IconNames["FolderOpen"] = "OpenFolderHorizontal";
    IconNames["Forward"] = "Forward";
    IconNames["Glimmer"] = "Glimmer";
    IconNames["GridViewMedium"] = "GridViewMedium";
    IconNames["Heart"] = "Heart";
    IconNames["HeartFill"] = "HeartFill";
    IconNames["Hide"] = "Hide3";
    IconNames["Home"] = "Home";
    IconNames["Layer"] = "Layer";
    IconNames["Link"] = "Link";
    IconNames["List"] = "List";
    IconNames["Mail"] = "Mail";
    IconNames["More"] = "More";
    IconNames["MoreVertical"] = "MoreVertical";
    IconNames["News"] = "News";
    IconNames["ODLink"] = "ODLink";
    IconNames["OEM"] = "OEM";
    IconNames["OfficeCatchUp"] = "OfficeCatchUp";
    IconNames["OneNoteLogo"] = "OneNoteLogo";
    IconNames["OpenFile"] = "OpenFile";
    IconNames["OpenInNewTab"] = "OpenInNewTab";
    IconNames["Page"] = "Page";
    IconNames["People"] = "People";
    IconNames["PhotoVideoMedia"] = "PhotoVideoMedia";
    IconNames["Pinned"] = "Pinned";
    IconNames["PowerPointLogo"] = "PowerPointLogo";
    IconNames["RedEye"] = "RedEye";
    IconNames["Remove"] = "Remove";
    IconNames["Reply"] = "Reply";
    IconNames["ReturnKey"] = "ReturnKey";
    IconNames["Rocket"] = "Rocket";
    IconNames["Share"] = "Share";
    IconNames["Sort"] = "Sort";
    IconNames["SortUp"] = "SortUp";
    IconNames["Stop"] = "Stop";
    IconNames["Sync"] = "Sync";
    IconNames["Trending"] = "Trending12";
    IconNames["Unfavorite"] = "Unfavorite";
    IconNames["Upload"] = "Upload";
    IconNames["Video"] = "Video";
    IconNames["ViewAll"] = "ViewAll";
    IconNames["VisioLogo"] = "VisioLogo";
    IconNames["WordLogo"] = "WordLogo";
})(IconNames || (IconNames = {}));
//# sourceMappingURL=IconNames.js.map